import { isProduction, debugMode } from '../env';


if (isProduction && !debugMode) {
  setInterval(() => {
    // eslint-disable-next-line
    debugger;
  }, 100);
}
